import { FC } from 'react';
import { useSharedState } from '../hooks/useSharedState';
import MonthPicker from './MonthPicker';
import styles from './PeriodPicker.module.css';
import { CustomDatePicker } from './CustomDatePicker';
import { DateUtil } from '../utils/DateUtil';
import TimePicker from './TimePicker';
import { getPeriodLabel } from '../utils/filterUtils';


interface PeriodPickerProps {
    readOnly?: boolean;
    period?: string;
    time?: string;
    onPeriodChange?: (period: string) => void;
    onTimeChange?: (time: string) => void;
}

const PeriodPicker: FC<PeriodPickerProps> = ({
    readOnly = false,
    period: controlledPeriod,
    time: controlledTime,
    onPeriodChange,
    onTimeChange
}) => {

    const [sharedPeriod, setSharedPeriod] = useSharedState('period', '');
    const [sharedTime, setSharedTime] = useSharedState('time', '');

    const period = controlledPeriod ?? sharedPeriod;
    const time = controlledTime ?? sharedTime;

    const setPeriod = (nextPeriod: string) => {
        if (onPeriodChange) {
            onPeriodChange(nextPeriod);
            return;
        }

        setSharedPeriod(nextPeriod);
    };

    const setTime = (nextTime: string) => {
        if (onTimeChange) {
            onTimeChange(nextTime);
            return;
        }

        setSharedTime(nextTime);
    };

    return <div className={styles.periodPickerContainer}>
        {(period === 'weekend' || period === 'next30Days') && <span className={`${styles.dateItem} ${styles.selected}`}>{getPeriodLabel(period)} <span className={styles.checkBadge} aria-hidden="true">✓</span></span>}
        {(!readOnly || DateUtil.isValidDateString(period)) && <CustomDatePicker selectedDate={DateUtil.isValidDateString(period) ? DateUtil.createLocalDateFromYMD(period) : null} onDateSelected={(date) => setPeriod(DateUtil.formatDateToLocalYMD(date??new Date()))}/>}
        {(!readOnly || period == "thisWeek") && <button type="button" className={[styles.dateItem, period == "thisWeek" ? styles.selected : ""].join(' ')} onClick={readOnly ? undefined : () => setPeriod("thisWeek")} aria-pressed={period == "thisWeek"}>Cette semaine {period == "thisWeek" && <span className={styles.checkBadge} aria-hidden="true">✓</span>}</button>}
        {(!readOnly || period == "nextWeek") && <button type="button" className={[styles.dateItem, period == "nextWeek" ? styles.selected : ""].join(' ')} onClick={readOnly ? undefined : () => setPeriod("nextWeek")} aria-pressed={period == "nextWeek"}>Semaine prochaine {period == "nextWeek" && <span className={styles.checkBadge} aria-hidden="true">✓</span>}</button>}
        {(!readOnly || (parseInt(period) >= 0 && parseInt(period) < 12)) && <MonthPicker readOnly={readOnly} selectedMonthIndex={parseInt(period) ?? -1} onMonthSelected={(m) => setPeriod(m.toString())}/>}
        <TimePicker readOnly={readOnly} selectedTime={time} onTimeSelected={(selectedTime) => setTime(selectedTime)}/>
    </div>;

}

export default PeriodPicker;
